import { createSlice, createAction } from "@reduxjs/toolkit";
import * as actionTypes from '../actions/actionTypes';


export const getInitialState = () => ({
    filesIsLoading: false,
    filesHasErrored: false,
    authenticated: false,
		isRemoving: false,
		isPublishing: false,
    selectedFilesIsLoading: false,
    data: []
});


export const filesSlice = createSlice({
	name: 'files',
	initialState: getInitialState(),
	extraReducers: (builder) => {
		builder
			.addCase(actionTypes.FILES_FETCH_DATA_SUCCESS, (state, action) => {
				return {
					...state,
					filesIsLoading: false,
					selectedFilesIsLoading: false,
					data: Object.values(action.response),
					authenticated: action.authenticated || false
				};
			})
			.addCase(actionTypes.FILES_IS_LOADING, (state, action) => {
				state.filesIsLoading = action.isLoading
			})
			.addCase(actionTypes.FILES_IS_REMOVING, (state, action) => {
				state.isRemoving = action.isRemoving
			})
			.addCase(actionTypes.FILES_IS_PUBLISHING, (state, action) => {
				state.isPublishing = action.isPublishing
			})
			.addCase(actionTypes.SELECTED_FILES_IS_LOADING, (state, action) => {
				state.selectedFilesIsLoading = action.selectedFilesIsLoading
			})
			.addCase(actionTypes.FILES_HAS_ERRORED, (state, action) => {
				state.filesHasErrored = action.hasErrored
				state.filesIsLoading = false
			})
			.addCase(actionTypes.RECOGNIZEREVENUE_IS_LOADING, (state, action) => {
			state.isLoading = action.isLoading
			})
						.addCase(actionTypes.RECOGNIZEREVENUE_FETCH_DATA_SUCCESS, (state, action) => {
							return {
								...state,
								filesIsLoading: false,
								selectedFilesIsLoading: false,
								data: Object.values(action.response),
								authenticated: action.authenticated || false
							};
						});
				}
			});
			



export const filesReducer = filesSlice.reducer;